import { render, staticRenderFns } from "./schoolList.vue?vue&type=template&id=3a4747ac&scoped=true&"
import script from "./schoolList.vue?vue&type=script&lang=js&"
export * from "./schoolList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4747ac",
  null
  
)

export default component.exports